import {HttpService} from "../http/HttpService";
import {AbstractAdminEntityService} from "./AbstractAdminEntityService";
import {CasinoCategorySeoEditor, CasinoLobbyCategory, ListCasinoLobbyCategoryResponse, SaveCasinoCategorySeoRequest, SeoMetadata} from "../http/protocol";


export class CasinoCategoryService  extends AbstractAdminEntityService<CasinoLobbyCategory, ListCasinoLobbyCategoryResponse>  {

    constructor(http : HttpService) {
        super("/casino-category", http)
    }

    /** The category's stored SEO per locale, plus the fallbacks the editor shows for empty fields. */
    getSeo(categoryId: number): Promise<CasinoCategorySeoEditor> {
        return this.http.get(`${this.entityPath}/${categoryId}/seo`);
    }

    /**
     * Stores the sent locales and returns every stored entry; a rejected save answers 400 with the reason as a
     * plain-text body.
     */
    saveSeo(categoryId: number, request: SaveCasinoCategorySeoRequest): Promise<SeoMetadata[]> {
        return this.http.put(`${this.entityPath}/${categoryId}/seo`, request);
    }

}
